import React from "react";
import { ChevronLeft } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import Constants from "../../constants";
import { CLEAR_PREVIEW_ITEM, SET_SELECTED_MENU } from "../../store/actions/configurationActions";
import { SET_SHOW_MOBILE_SUMMARY } from "../../store/actions/menuActions";
import { getMenuItems, getPreviewItem, getSelectedMenu, getShowMobileSummary } from "../../store/sagas/selectors";
import { useText } from "../../utilities/textUtil";
import { MobileReadmoreCard } from "../Readmore/MobileReadmoreCard";
import { SummaryItems } from "../Summary/SummaryItems";
import { MobileMainMenu } from "./MobileMainMenu";
import { MobileProductMenu } from "./MobileProductMenu";

const MenuArea = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: calc(100% - ${Constants.mobileImageHeightVw}vw - 76px);
    overflow: auto;
    padding: 0 18px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const BackButton = styled.div`
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    padding: 5px 5px 5px 0;
    white-space: nowrap;
`;

const ScrollContainer = styled.div`
    overflow: auto;
    flex-grow: 1;
    width: 100%;
`;

export const MobileMenuArea = () => {
    const dispatch = useDispatch();
    const selectedMenu = useSelector(getSelectedMenu);
    const currentItems = useSelector(getMenuItems);
    const previewItem = useSelector(getPreviewItem);
    const showMobileSummary = useSelector(getShowMobileSummary);
    const t = useText();
    const items = selectedMenu && currentItems[selectedMenu];

    const handleBack = () => {
        if (showMobileSummary) {
            dispatch({ type: SET_SHOW_MOBILE_SUMMARY, showMobileSummary: false });
            dispatch({ type: CLEAR_PREVIEW_ITEM });
        } else if (previewItem) {
            dispatch({ type: CLEAR_PREVIEW_ITEM });
        } else if (items) {
            dispatch({ type: SET_SELECTED_MENU, selectedMenu: null });
        }
    };

    const renderContent = () => {
        if (showMobileSummary) return <SummaryItems />;
        if (previewItem) return <MobileReadmoreCard item={previewItem} />;
        if (items) return <MobileProductMenu items={items} />;
        return <MobileMainMenu />;
    };

    return (
        <MenuArea>
            <BackButton
                onClick={handleBack}
                style={{ visibility: showMobileSummary || previewItem || items ? "visible" : "hidden" }}
            >
                <ChevronLeft size={16} color="#000000" style={{ position: "relative", top: "2px" }} />
                {t("menuBack")}
            </BackButton>
            <ScrollContainer>{renderContent()}</ScrollContainer>
        </MenuArea>
    );
};
